import { render, staticRenderFns } from "./ProcessErrorsTable.vue?vue&type=template&id=5bf0f954&scoped=true"
import script from "./ProcessErrorsTable.vue?vue&type=script&lang=js"
export * from "./ProcessErrorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0f954",
  null
  
)

export default component.exports